<mat-label class="subHeading"
  >Partner Code Type<span *ngIf="isRequired" class="star">*</span></mat-label
>
<mat-select class="insurer" formControlName="partnerCode">
  <mat-option *ngFor="let partnerCode of partnerCodeList" [value]="partnerCode">
    {{ partnerCode }}
  </mat-option>
</mat-select>
